import { render } from "./BehaviorSummary.vue?vue&type=template&id=2609d412&scoped=true"
import script from "./BehaviorSummary.vue?vue&type=script&lang=js"
export * from "./BehaviorSummary.vue?vue&type=script&lang=js"

import "./BehaviorSummary.vue?vue&type=style&index=0&id=2609d412&lang=scss&scoped=true"

import exportComponent from "/home/jenkins/workspace/qixiao_410_6413_沙箱云前端生产环境/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2609d412"]])

export default __exports__